import m from '@bitstillery/mithril'
import {MithrilComponent} from '@bitstillery/mithril'
import {Country, Dropdown, Icon} from '@bitstillery/common/components/portal'
import {classes} from '@bitstillery/common/lib/utils'
import {set_language, supported_languages} from '@bitstillery/common/lib/i18n'
import {$s, $t} from '@bitstillery/common/app'

export class BarLanguageSwitcher extends MithrilComponent<{
    className?: string
    /** Default `right` (header). Use `left` in full-width sheets so the menu aligns flush. */
    menu_align?: 'left' | 'right'
}> {
    view(
        vn: m.Vnode<{
            className?: string
            menu_align?: 'left' | 'right'
        }>,
    ) {
        const {className, menu_align = 'right'} = vn.attrs
        const current_language = supported_languages.find(([code]) => code === $s.language)
        return (
            <Dropdown className={classes('bar-language-dropdown', className, menu_align === 'right' ? 'right' : null)}>
                <div className='bar-nav-item bar-language-trigger' title={$t('my_portal.preferences.language')}>
                    <Country className='bar-language-trigger-flag' language={$s.language} size='d' type='only_flag' />
                    {menu_align === 'left' && current_language ? (
                        <span className='bar-language-trigger-label'>{current_language[1]}</span>
                    ) : null}
                    <Icon className='bar-language-trigger-chevron' name='chevronDown' size='s' type='info' />
                </div>
                <div className='dropdown-body'>
                    {supported_languages.map(([code, name]) => (
                        <div
                            key={code}
                            className={classes('sub-menu', 'bar-language-option', {
                                active: $s.language === code,
                            })}
                            onclick={() => {
                                void set_language(code)
                            }}
                        >
                            <Country language={code} size='s' type='only_flag' />
                            <span>{name}</span>
                        </div>
                    ))}
                </div>
            </Dropdown>
        )
    }
}
